import styled from "styled-components";

export const Styles = styled.div`
  .desktop & {
    --color-un_active: #f0f0f0;
    --color-active: #434343;
  }
  .mobile & {
    --color-active: #ffffff;
    --color-un_active: #434343;
  }
  display: flex;
  justify-content: center;
  background: var(--bg-item);
  padding: 24px 0;
  border-radius: 8px;
  .wrapper-clock {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;
